module.exports = __webpack_public_path__ + "static/media/sla-logo.0f607057.png";